import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import Logo from '../../assets/img/logo/logo-white-3.png';

const FooterTwo = (props) => {
  const { footerClass, footerLogo, copyrightClass } = props;
  return (
    <footer>
      <div
        className={
          footerClass
            ? footerClass
            : 'it-footer-area it-footer-style-2 black-bg p-relative fix z-index p-relative'
        }
      >
        <div className="container">
          <div className="p-relative pt-130 pb-70">
            <div className="row">
              <div
                className="col-xl-3 col-lg-3 col-md-4 mb-50 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                <div className="it-footer-widget-item footer-col-1-1">
                  <h4 className="it-footer-widget-title">Contact Us:</h4>
                  <div className="it-footer-widget-contact">
                    <div className="d-flex align-items-center mb-30">
                      <div className="it-footer-contact-icon">
                        <span>
                          <i className="flaticon-phone-call"></i>
                        </span>
                      </div>
                      <div className="it-footer-contact-text">
                        <span>Phone:</span>
                        <a className="hover-anim white" href="tel:00875784568">
                          (00) 875 784 568
                        </a>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="it-footer-contact-icon">
                        <span>
                          <i className="flaticon-letter"></i>
                        </span>
                      </div>
                      <div className="it-footer-contact-text">
                        <span>E-mail:</span>
                        <a
                          className="hover-anim white"
                          href="mailto:info@gmail.com"
                        >
                          info@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-5 col-lg-6 col-md-8 mb-50 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                <div className="it-footer-widget-item footer-col-2-2">
                  <h4 className="it-footer-widget-title">Quick Links:</h4>
                  <div className="row">
                    <div className="col-xl-4 col-lg-3 col-md-4 col-4">
                      <div className="it-footer-list list-style-1">
                        <ul>
                          <li>
                            <a href="#">Home</a>
                          </li>
                          <li>
                            <a href="#">About</a>
                          </li>
                          <li>
                            <a href="#">Pages</a>
                          </li>
                          <li>
                            <a href="#">Shop</a>
                          </li>
                          <li>
                            <a href="#">Features</a>
                          </li>
                          <li>
                            <a href="#">Pricing</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-3 col-md-4 col-4">
                      <div className="it-footer-list list-style-2">
                        <ul>
                          <li>
                            <a href="#">Contact</a>
                          </li>
                          <li>
                            <a href="#">Customers</a>
                          </li>
                          <li>
                            <a href="#">Enterprice</a>
                          </li>
                          <li>
                            <a href="#">Partners</a>
                          </li>
                          <li>
                            <a href="#">Blog Post</a>
                          </li>
                          <li>
                            <a href="#">Support</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-3 col-md-4 col-4">
                      <div className="it-footer-list list-style-3">
                        <ul>
                          <li>
                            <a href="#">Terms of User</a>
                          </li>
                          <li>
                            <a href="#">Terms & Condition</a>
                          </li>
                          <li>
                            <a href="#">Privacy & Policy</a>
                          </li>
                          <li>
                            <a href="#">Cookie & Policy</a>
                          </li>
                          <li>
                            <a href="#">Team Members</a>
                          </li>
                          <li>
                            <a href="#">Newsroom</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="it-footer-newsletter-wrap d-flex align-items-center justify-content-center">
              <div className="text-center">
                <h4 className="it-contact-title mb-10">
                  Subscribe To our <br />
                  Newsletter
                </h4>
                <div className="it-footer-contact-text mb-20">
                  <p>
                    Printer took a galley of type and scrambled to <br /> make a
                    type specimen book.
                  </p>
                </div>
                <form action="#">
                  <div className="row gx-20">
                    <div className="col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="Name" />
                      </div>
                    </div>
                    <div className="col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="email" placeholder="E-mail" />
                      </div>
                    </div>
                  </div>
                  <div className="it-footer-button-box d-flex align-items-center justify-content-center">
                    <button type="submit" className="it-btn-theme p-relative">
                      <Button btnText="Subscribe Now" />
                    </button>
                    <div className="it-footer-button-icon">
                      <span>
                        <i className="fa-light fa-paper-plane"></i>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          copyrightClass
            ? copyrightClass
            : 'it-copyright-area it-copyright-height it-copyright-style-2'
        }
      >
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-xxl-3 col-xl-4 col-lg-3 col-md-6 d-none d-md-block wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="it-copyright-logo">
                <Link to="/">
                  <img src={footerLogo ? footerLogo : Logo} alt="" />
                </Link>
              </div>
            </div>
            <div
              className="col-xxl-5 col-xl-4 col-lg-4 d-none d-lg-block wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="it-copyright-social text-center">
                <span>Follow Us:</span>
                <a href="#" className="me-1">
                  <i className="flaticon-facebook-app-symbol"></i>
                </a>
                <a href="#" className="me-1">
                  <i className="flaticon-twitter"></i>
                </a>
                <a href="#">
                  <i className="flaticon-skype"></i>
                </a>
              </div>
            </div>
            <div
              className="col-xxl-4 col-xl-4 col-lg-5 col-md-6 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="it-copyright-text text-center text-md-end">
                <p>
                  Copyright © 2024 <a href="#">Medito </a> || All Rights
                  Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
